import classNames from 'classnames';
import { ReactNode } from 'react';
import { fontWeights, Paragraph, paragraphSizes } from '../typography';

type IllustrationCardProps = {
  icon: (classes: string) => ReactNode;
  title: string;
  subtitle: string;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
};

export const IllustrationCard = ({
  icon,
  title,
  subtitle,
  disabled = false,
  className,
  ...props
}: IllustrationCardProps) => {
  const classes = classNames(
    'flex flex-row sm-initial:flex-col gap-5 w-full rounded-21 p-6 group cursor-pointer text-left',
    {
      'bg-primary-lighter-06 hover:bg-primary-lighter-13 text-primary active:bg-primary-lighter-13 focus:bg-primary-lighter-13 focus:ring-2 focus:ring-primary focus:ring-inset':
        !disabled,
      'bg-white-snow hover:bg-white-snow focus:bg-white-snow active:bg-white-snow text-gray-silver cursor-not-allowed':
        disabled,
    },
    className,
  );

  const iconClasses = classNames({
    'fill-primary hover:fill-primary': !disabled,
    'fill-gray-silver': disabled,
  });

  return (
    <button type='button' disabled={disabled} className={classes} {...props}>
      <div>{icon(iconClasses)}</div>
      <div className='transition-translate duration-200 transform translate-y-2/4 group-hover:translate-y-0 group-active:translate-y-0'>
        <Paragraph size={paragraphSizes.large} weight={fontWeights.semibold}>
          {title}
        </Paragraph>
        <Paragraph
          size={paragraphSizes.normal}
          weight={fontWeights.medium}
          className='transition-opacity ease-linear delay-100 duration-200 opacity-0 group-hover:opacity-100 group-active:opacity-100'
        >
          {subtitle}
        </Paragraph>
      </div>
    </button>
  );
};
